import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SetupApprovalPageRoutingModule } from './setup-approval-routing.module';

import { SetupApprovalPage } from './setup-approval.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SetupApprovalPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [SetupApprovalPage]
})
export class SetupApprovalPageModule {}
